import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SnippetsOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { SigningStatus } from "gql/graphql";
import Tag from "@/shared/data-display/tag";
import { useTranslations } from "use-intl";

type StatusBadgeProps = {
  status: SigningStatus;
};

export function SigningStatusBadge({ status }: StatusBadgeProps) {
  const t = useTranslations("Signing");

  return (
    <>
      {status === SigningStatus.Draft && (
        <Tag color={"default"} icon={<SnippetsOutlined />}>
          {t(SigningStatus.Draft)}
        </Tag>
      )}
      {status === SigningStatus.InProgress && (
        <Tag color={"processing"} icon={<SyncOutlined />}>
          {t(SigningStatus.InProgress)}
        </Tag>
      )}
      {status === SigningStatus.Signed && (
        <Tag color={"success"} icon={<CheckCircleOutlined />}>
          {t(SigningStatus.Signed)}
        </Tag>
      )}
      {status === SigningStatus.Rejected && (
        <Tag color={"error"} icon={<CloseCircleOutlined />}>
          {t(SigningStatus.Rejected)}
        </Tag>
      )}
    </>
  );
}
